import React, { useEffect, useState } from 'react';
import { CacheProvider } from '@emotion/react';
import Link from '@mui/material/Link';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { addDataPosition, appendStyleSheet, getEndpoint, getID, getMUICache, getUrl, getImageSize, getImageUrl, GetFallBackImage, isImageSizeBlank, getImageId, fetchAnchorValue } from '../../../common/utils';
//import { appendStyleSheet, getEndpoint, getID, getMUICache, getUrl } from './../../../common/utils';
import { I_CDSListingItemTO } from '@interfaces/ICDSListingResponseTO';
import "./WebStoriesThree.css";
import { PAGEBUILDER_URLS } from '../../Common/Constant';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import bcrypt from 'bcryptjs-react';
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages, PreloadViewportImages, ImageLoader } from '../../../components/IntersectionObserver/imageComponent';

import { IconButton } from '@mui/material';
//import styles from '!!raw-loader!./WebStoriesThree.css';

WebStoriesThree.version = 1000;

WebStoriesThree.lang = 'en';
WebStoriesThree.langs = [
  'en'
];
WebStoriesThree.setLang = (lang: any) => {
  WebStoriesThree.lang = lang;
}

Object.defineProperty(WebStoriesThree, 'name', {
  writable: true,
  value: 'WebStoriesThree'
});

const NextArrow = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: "block", background: "#585858", color: "#fff", right: "0", zIndex: "5", width: "32px", height: "32px", borderRadius: "4px" }} onClick={onClick}>

      <IconButton className='CustomPrevArrow'>
        <ArrowForwardIosOutlinedIcon />
      </IconButton>

    </div>
  );
}

const PrevArrow = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: "block", background: "#585858", color: "#fff", left: "0", zIndex: "5", width: "32px", height: "32px", borderRadius: "4px" }} onClick={onClick}>
      {/* <KeyboardArrowLeftIcon fontSize='medium' /> */}
      <IconButton className='CustomNextArrow'>
        <ArrowBackIosNewOutlinedIcon />
      </IconButton>
    </div>
  );
}

export function WebStoriesThree(props: any) {
  AddImageDimensions();
  SetHighPriorityImages();
  PreloadViewportImages();
  ImageLoader();
  useEffect(() => {
    EagerLoadImages()
  }, []);

  const { showDate, anchorLinksValue } = props;
  let styles = require("./WebStoriesThree.css");
  const [msid, setMsid] = useState<any>('');
  const [items, setItems] = useState<I_CDSListingItemTO[]>([]);
  appendStyleSheet("WebStoriesThree", styles);

  const endpoint = getEndpoint(props);
  useEffect(() => {
    if (!endpoint.isSSR || !endpoint.SSRDataObj) {
      fetchComponentData();
    }
  }, [props.MSID, endpoint, props.showAdSlot]);

  const setItemsObj = (response: any) => {
    setItems(response?.items)
  }

  if (endpoint.isSSR && endpoint.SSRDataObj && (!items || !items.length)
    && endpoint.SSRDataObj.pg && Object.keys(endpoint.SSRDataObj.pg).length != 0
    && endpoint.SSRDataObj.pg.tr != 'null' && endpoint.SSRDataObj.items && endpoint.SSRDataObj.items.length != 0) {
    setItemsObj(endpoint.SSRDataObj);
  }

  const fetchComponentData = () => {
    getData(getUrl(props));
  }

  const getData = (url: string) => {
    let headerString = '?' + url.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const headers = { 'p-nonce': headerString };

    fetch(url, { headers: headers })
      .then((response) => response.json())
      .then(response => {
        setItemsObj(response);
      })
      .catch(err => {
        //console.log(err);
      });
  }

  const carouselRef = React.useRef(null);

  const getRenderPart = () => {
    if (msid && props.msid && msid != props.msid) {
      props.queryParams.msid = props.msid;
      setMsid(props.queryParams.msid);
      getData(getUrl(props));
    }

    if (!items || !items.length) {
      return "";
    }

    let i_scrollMode = true;
    if (props.scroll == props.CONSTANTS.SCROLL_MODE.MANUAL) {
      i_scrollMode = false;
    }

    //let componentClasses = getClasses(props.data);
    let componentID = getID(props.data);

    let blockHeading: any = '';
    if (props.mainHeading) {
      blockHeading = <div className="ThemeTwoTrnHeadingWrap">
        <h3 className='ThemeTwoTrnHeading' style={{ color: props.mainHeadingColor }}>{props.mainHeading}</h3>
      </div>;
    }

    const Carouselsettings = {
      infinite: true,
      speed: 500,
      autoplay: i_scrollMode,
      slidesToShow: 4,
      slidesToScroll: parseInt(props.scrollCount, 10),
      initialSlide: 0,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      swipeToSlide: true,
      variableWidth: true,
      dots: true,
      arrows: false,
      className: 'ThemeThreeWebstroies',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: props.scrollCount,
            variableWidth: true,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: props.scrollCount,
            variableWidth: true,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            variableWidth: true,

          }
        }
      ]
    };

    let bodySnippet: any;
    if (typeof window !== 'undefined' && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url))) {
      bodySnippet = `<div className=\'breaking-news\' style="width: 259px;text-align: center;">Ad Slot<br>259 X 79</div>`
    } else {
      bodySnippet = props.bodyAdScript + props.bodyAdMobileScript;
    }

    return <CacheProvider value={getMUICache()}>
      <div id={componentID} className='themeTwoWebStroiesSlideWrap'>
        <div className='commoncontainer'>
          {blockHeading}

          <div>
            <Slider {...Carouselsettings} ref={carouselRef}>
              {items &&
                items.map((itemObj, index) => {
                  if (props.showAdSlot) {
                    if (props.adNetwork === "google" && index === 2) {
                      return <div key={'0_' + index} className='breaking-news' dangerouslySetInnerHTML={{ __html: addDataPosition(bodySnippet, index) }}></div>
                    } else if (props.adNetwork === "can") {
                      if ((index + 1) % 4 === 3) {
                        return <div key={'0_' + index} className='breaking-news' dangerouslySetInnerHTML={{ __html: addDataPosition(bodySnippet, index) }}></div>
                      }
                    }
                  }
                  return <div key={'wsitem_' + index} className='ThemeTwoWebCardWrapSlide'>
                    <div className='ThemeTwoWebCardWrap'>
                      <div className='ThemeTwoWebCardImgWrap'>

                        {isImageSizeBlank(itemObj.imageid) ? <picture>
                          <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(itemObj.imageid), getImageSize(itemObj.imageid), 475, 376, "", false, props.CONSTANTS, '8')} />
                          <source media="(max-width: 767px)" srcSet={getImageUrl(getImageId(itemObj.imageid), getImageSize(itemObj.imageid), 265, 354, "", false, props.CONSTANTS, '8')} />
                          <img alt={itemObj?.hl?.slice(0, 25)} title={itemObj?.hl?.slice(0, 25)} loading="lazy" />
                        </picture> : <img src={GetFallBackImage()} alt={itemObj?.hl?.slice(0, 25)} title={itemObj?.hl?.slice(0, 25)} loading="lazy" />}
                      </div>
                      <div className='ThemeTwoWebCarContentWrap'>
                        <Link className='webStroiesDiscription' href={itemObj.wu} key={'2_' + index} target={fetchAnchorValue(anchorLinksValue, itemObj.wu)}>{itemObj.hl}</Link>
                        {showDate && <p className='webStroiesDateTime'>April 5, 2024, 12:11 PM</p>}
                      </div>
                      <div className='ThemeTwoWebCarIconWrap'>
                        {/* <WebStoriesOutlinedIcon /> */}
                        <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M26.2381 4.14267C26.2381 3.37999 26.8564 2.76172 27.619 2.76172C28.3817 2.76172 29 3.37999 29 4.14267V23.476C29 24.2387 28.3817 24.857 27.619 24.857C26.8564 24.857 26.2381 24.2387 26.2381 23.476V4.14267Z" fill="white" />
                          <path d="M0 4.14267C0 3.37999 0.618273 2.76172 1.38095 2.76172C2.14363 2.76172 2.7619 3.37999 2.7619 4.14267V23.476C2.7619 24.2387 2.14363 24.857 1.38095 24.857C0.618273 24.857 0 24.2387 0 23.476V4.14267Z" fill="white" />
                          <mask id="path-2-inside-1_885_3513" fill="white">
                            <rect x="5.53125" width="17.9524" height="27.619" rx="2" />
                          </mask>
                          <rect x="5.53125" width="17.9524" height="27.619" rx="2" stroke="white" strokeWidth="5" mask="url(#path-2-inside-1_885_3513)" />
                        </svg>


                      </div>
                    </div>
                  </div>

                }
                )}
            </Slider>
          </div>
        </div>
      </div>
    </CacheProvider>
  }


  return (
    <>
      {getRenderPart()}
    </>
  );

}